import React from 'react';
import styles from './MainTitle.module.scss';

const MainTitle = ({ children }) => <h1 className={styles.root}>{children}</h1>;

export default MainTitle;
